import en from './en.json';
import fr from './fr.json';
import es from './es.json';
import pt from './pt.json';

export const defaultLocale = 'fr';

export const languages = {
  en,
  fr,
  es,
  pt,
};
